export const SHIPMENT_EXPRESS = 15;
export const SHIPMENT_STANDARD = 0;
